import ajax from './ajax';

/* eslint-disable import/prefer-default-export */
export function requestLogin(data) {
  return ajax('/resources/api/token/', { method: 'POST', data });
}

export function changePassword(data) {
  return ajax('/users/change-password/', { method: 'PUT', data });
}

export function getResetPasswordEmail(data) {
  return ajax('/resources/forgot/password/check/email/', { method: 'POST', data });
}

export function verifyResetPasswordToken(data) {
  return ajax('/resources/validate/forgot/password/token/', { method: 'POST', data });
}

export function confirmNewPassword(data) {
  return ajax('/resources/set/new/password/', { method: 'POST', data });
}

export function checkEmail(data) {
  return ajax('/resources/check/email/', { method: 'POST', data });
}

export function resetPassword(data) {
  return ajax('/resources/reset/password/', { method: 'POST', data });
}
export function requestIpConfirm(data) {
 
  return ajax('/resources/confirm-ip-email/', { method: 'POST', data });
}

export function requestCode(data) {
  return ajax('/resources/send-code/', { method: 'POST', data });
}

export function requestAddDevice(data) {
  return ajax('/resources/add-device/', { method: 'POST', data });
}
